import {SET_ENRICH_PRODUCTS,POST_ENRICH_PRODUCT,SET_ENRICH_PRODUCT,
        ENRICH_PRODUCT_SKIP,INIT_ENRICH_PRODUCT} from './types'
import axios from 'axios';



// export const setAuditEnrichProduct = (dataObj) => async dispatch => {
//     let url = `/marketplace/static/php/web/b2bWebsite.php?action=fetchEnrichmentProduct&queueType=brandedEnrich`
//     console.log('url',url);
//     axios.get(url)
//         .then(data => {
//         dispatch({
//             type: SET_ENRICH_PRODUCT,
//             payload : {
//                 data : data
//             }
//         })
//     })
// }

export const setAuditEnrichProduct = (dataObj) => async dispatch => {
        console.log(' from auditEnrich setAuditEnrichProduct',dataObj);
    if (dataObj) {
        dispatch({
            type: INIT_ENRICH_PRODUCT,
            payload : dataObj
        })
    }else {
        console.log('into else');
         dispatch({
        type: INIT_ENRICH_PRODUCT,
        payload : null
    })  
    }
    
}

export const setAuditEnrichData = (dataObj) => async dispatch =>{
    let url = `/vendorapis/contractor/contractor/getEnrichmentProduct?productId=${dataObj.productId}&enrich=true`;
    console.log('url==>',url);
    axios.get(url)
        .then(data => {
            console.log("data=>",data)
            dispatch({
                type: SET_ENRICH_PRODUCTS,
                payload: {
                    data : data
                }
            })
        });
}

export const postAuditEnrichData = (payload) => async dispatch => {
    console.log('payload',payload);
    let url = `/vendorapis/contractor/contractor/saveAuditorData?token=&productId=${payload.finalObj.id}`
    console.log('postAuditEnrichDataUrl=>', url);
    try {
        const res = await axios.post(url,payload.finalObj.data)
    console.log('res.data.results.code=>',res.data.results.code)
    
    if (res.data.results.code == 0){
        console.log('inside res.data',res.data,'POST_ENRICH_PRODUCT',POST_ENRICH_PRODUCT);
        dispatch({
            type: POST_ENRICH_PRODUCT,
            payload : res.data 
        })
        // payload.cb(res.data)
        payload.cb && payload.cb(res.data)
    }
    } catch (error) {
        console.log('error =>',error)
        
    }

}

export const skipAuditEnrichData = (payload) => async dispatch => {
    console.log('payload from skipAuditEnrichData payload',payload);
    const url = `/marketplace/static/php/web/b2bWebsite.php?action=skipAuditProduct&variantId=${payload.id}&queueType=brandedEnrich`
    console.log('skipAuditEnrichData url -->',url);
    axios.get(url)
        .then(data=> {
            console.log('skipAuditEnrichData data',data.data);
            if (data.data.status == 1) {
                dispatch({
                    type: ENRICH_PRODUCT_SKIP,
                    payload : {
                        data : data
                    }
                })
                payload.cb && payload.cb(data.data)
            }
        })
}